var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 350",
    width: 900,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 150L12.5 150.5C25 151 50 152 75 148C100 144 125 135 150 141.3C175 147.7 200 169.3 225 178.2C250 187 275 183 300 179.8C325 176.7 350 174.3 375 169.7C400 165 425 158 450 161.5C475 165 500 179 525 190.2C550 201.3 575 209.7 600 210.2C625 210.7 650 203.3 675 191C700 178.7 725 161.3 750 160C775 158.7 800 173.3 825 175.8C850 178.3 875 168.7 887.5 163.8L900 159L900 0L887.5 0C875 0 850 0 825 0C800 0 775 0 750 0C725 0 700 0 675 0C650 0 625 0 600 0C575 0 550 0 525 0C500 0 475 0 450 0C425 0 400 0 375 0C350 0 325 0 300 0C275 0 250 0 225 0C200 0 175 0 150 0C125 0 100 0 75 0C50 0 25 0 12.5 0L0 0Z",
    fill: "#b8d1df",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave-2.c5bde1a119169ff6949b8bb6fb176569.svg";
export { ForwardRef as ReactComponent };